import { Container, ContainerDDM, DDM, InvisibleContainer, LContainer, Logo, LogoContainer, MenuItemB, NT, NavigateButton1, NavigateButton2, NavigateButton3, NavigateButton4, P, RContainer, Span1DDM, Span1MIB, Span2DDM, Span2MIB, Span3DDM, Span3MIB } from "./styles";
import { useContext, useCallback, useEffect, useRef } from 'react';
import { menuContext } from "../../contexts/menuUser";
import L from "../../assets/tutelogo.png";
import { HiOutlineMenu } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

function Header() {
    const { openMenu, setOpenMenu } = useContext(menuContext);
    const menuButtonRef = useRef<HTMLDivElement>(null); 
    const menuRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    const items = [
        { name: "Clube", link: "/Time" },
        { name: "Títulos", link: "/Historia" },
        { name: "Elenco", link: "/Jogadoras" },
        { name: "Patrocinadores", link: "/Patrocinadores" }
    ];

    const handleNavigate = (link: string) => {
        navigate(link);
        setOpenMenu(false); 
    };

    const handleButtonClick = useCallback((event: React.MouseEvent) => {
        event.stopPropagation();
        setOpenMenu(prevState => !prevState);
    }, [setOpenMenu]);

    const closeMenuOnOutsideClick = (event: MouseEvent) => {
        if (menuButtonRef.current && !menuButtonRef.current.contains(event.target as Node) &&
            menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setOpenMenu(false); 
        }
    };

    const handleResize = () => {
        if (window.innerWidth > 768) {
            setOpenMenu(false);
        }
    };

    useEffect(() => {
        if (openMenu) {
            document.addEventListener('mousedown', closeMenuOnOutsideClick);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            document.removeEventListener('mousedown', closeMenuOnOutsideClick);
            window.removeEventListener('resize', handleResize);
        };
    }, [openMenu]);

    return (
        <Container>
            <LContainer>
                <LogoContainer>
                    <Logo alt="Logo" src={L} onClick={() => navigate("/")} />
                </LogoContainer>
                <NavigateButton1 onClick={() => navigate("/Time")}>
                    <NT>Clube</NT>
                </NavigateButton1>
                <NavigateButton2 onClick={() => navigate("/Historia")}>
                    <NT>Títulos</NT>
                </NavigateButton2>
                <NavigateButton3 onClick={() => navigate("/Jogadoras")}>
                    <NT>Elenco</NT>
                </NavigateButton3>
            </LContainer>
            <RContainer>
                <NavigateButton4 onClick={() => navigate("/Patrocinadores")}>
                    <P>Patrocinadores</P>
                </NavigateButton4>
                <DDM onClick={handleButtonClick} ref={menuButtonRef}>
                    <Span1DDM />
                    <Span2DDM />
                    <Span3DDM>
                        <HiOutlineMenu />
                    </Span3DDM>
                </DDM>
                <InvisibleContainer openMenu={openMenu}>
                    <ContainerDDM openMenu={openMenu} ref={menuRef}>
                        {items.map((item, index) => (
                            <MenuItemB key={index} onClick={() => handleNavigate(item.link)}>
                                <Span1MIB />
                                <Span2MIB />
                                <Span3MIB>{item.name}</Span3MIB>
                            </MenuItemB>
                        ))}
                    </ContainerDDM>
                </InvisibleContainer>
            </RContainer>
        </Container>
    );
}

export default Header;
